<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  height: 100%;
  -ms-overflow-style: none;
  overflow: hidden;
  margin: -4px -6px;
  padding: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}
html,body {
  height: 100%;
  background-color: rgba(0,0,0,0);
  -ms-overflow-style: none;
  overflow: hidden;
  margin: -4px -6px;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue